import gql from 'graphql-tag'

export default gql`query getPocketGuide {
	getPocketGuide {
    id
		img_header
		file_audio_guide
		details {
			id
			title
			content
			language_code
		}
	}
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/pocketGuide/get.js